import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SearchBox from '../components/SearchBox';
import SelectBox from '../components/SelectBox';
import Button from 'react-bootstrap/Button';

import {
  ColXsMdType,
  LeaveFilterType,
  LocationFilterType,
  SelectOptionType,
} from '../utils/Types';
import {
  DEFAULT_OPTION,
  DEFAULT_OPTION_LOCATION,
  LEAVE_PAGE_TYPE,
  ROLE_POSP,
  ROLE_KSHEMA_POSP,
  TEXT_ONLY_REGEX,
} from '../utils/Constant';
import KDateRangePicker from '../components/KDateRangePicker';
import { DateRange } from 'mui-daterange-picker-plus';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import {
  attendanceSelector,
  fetchLeaveTypeDrops,
  fetchStatusDrops,
} from '../features/attendanceSlice';
import { trackLocationSelector } from '../features/trackLocationSlice';
import LocationFilter from './LocationFilter';
import moment from 'moment';

const defaultFilter: LeaveFilterType = {
  employeeUniqueId: '',
  employeeName: '',
  zone: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  role: DEFAULT_OPTION,
  city: DEFAULT_OPTION,
  district: DEFAULT_OPTION,
  leaveType: DEFAULT_OPTION_LOCATION,
  fromDate: undefined,
  toDate: undefined,
  status: DEFAULT_OPTION_LOCATION,
};
const colSize: ColXsMdType = {
  xs: 6,
  md: 6,
};
interface ILeavesFilterProps {
  onApplyFilters: (filter: LeaveFilterType) => void;
  type: string | null;
}

const LeavesFilter: React.FunctionComponent<ILeavesFilterProps> = ({
  onApplyFilters,
  type,
}) => {
  const [filter, setFilter] = useState<LeaveFilterType>(defaultFilter);
  const roleOptionsRaw = useAppSelector(trackLocationSelector).roleOptions;
  const dispatch = useAppDispatch();

  const roleOptions = roleOptionsRaw?.filter(
    (item: SelectOptionType) =>
      item.value !== ROLE_POSP && item.value !== ROLE_KSHEMA_POSP
  );

  const statusDropOptions: SelectOptionType[] =
    useAppSelector(attendanceSelector).statusDropOptions;

  const LeaveTypeDropOptions: SelectOptionType[] =
    useAppSelector(attendanceSelector).LeaveTypeDropOptions;

  const onResetFilter = () => {
    const newFilter = {
      ...defaultFilter,
    };
    onApplyFilters(newFilter);
    setFilter(newFilter);
  };

  useEffect(() => {
    dispatch(fetchStatusDrops({ module: 6 }));
    dispatch(fetchLeaveTypeDrops({ module: 4 }));
  }, []);

  let statusDropOptionValues = [DEFAULT_OPTION_LOCATION, ...statusDropOptions];

  if (type === LEAVE_PAGE_TYPE.APPROVE_LEAVE && statusDropOptions?.length) {
    statusDropOptionValues = statusDropOptions?.filter(
      (drop: any) => drop?.value === 22 || drop?.label === 'Pending'
    );
  }
  return (
    <div className="border rounded px-3 pt-2">
      <Row>
        <Col xs={6} md={3}>
          <SearchBox
            label="Search by Employee Id"
            placeHolder="Search"
            value={filter.employeeUniqueId}
            onChange={(e: any) => {
              setFilter({
                ...filter,
                employeeUniqueId: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <SearchBox
            label="Search by Employee Name"
            placeHolder="Search"
            value={filter.employeeName}
            onChange={(e: any) => {
              const text = e.target.value;
              if (TEXT_ONLY_REGEX.test(text) || text === '') {
                setFilter({
                  ...filter,
                  employeeName: e.target.value,
                });
              }
            }}
          />
        </Col>
        <Col xs={6} md={6}>
          <LocationFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            filterData={{
              zone: filter.zone,
              state: filter.state,
              district: filter.district,
              city: filter.city,
            }}
            setLocationFilter={(locationFilter: LocationFilterType) => {
              setFilter({
                ...filter,
                zone: locationFilter.zone,
                state: locationFilter.state,
              });
            }}
            hideCity={true}
            hideDistrict={true}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={3}>
          <SelectBox
            label="Role"
            className="css-select-bg"
            options={roleOptions}
            value={filter.role}
            onChange={(event: SelectOptionType) => {
              setFilter({
                ...filter,
                role: event,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectBox
            label="Leave Type"
            options={[DEFAULT_OPTION_LOCATION, ...LeaveTypeDropOptions]}
            className="css-select-bg"
            value={filter.leaveType}
            onChange={(event: SelectOptionType) => {
              setFilter({
                ...filter,
                leaveType: event,
              });
            }}
            showClear={false}
          />
        </Col>
        <Col xs={6} md={3}>
          <KDateRangePicker
            onApply={(dateRange: DateRange) => {
              setFilter({
                ...filter,
                fromDate: dateRange?.startDate
                  ? moment(dateRange?.startDate).toDate()
                  : moment().toDate(),
                toDate: dateRange?.endDate
                  ? moment(dateRange?.endDate).toDate()
                  : moment().toDate(),
              });
            }}
            startDate={filter.fromDate ?? moment().toDate()}
            endDate={filter.toDate ?? moment().endOf('year').toDate()}
          />
        </Col>
        {type === LEAVE_PAGE_TYPE.LEAVE_HISTORY && (
          <Col xs={6} md={3}>
            <SelectBox
              label="Status"
              options={statusDropOptionValues}
              className="css-select-bg"
              value={filter.status}
              onChange={(event: SelectOptionType) => {
                setFilter({
                  ...filter,
                  status: event,
                });
              }}
              showClear={false}
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col xs={6} md={4}>
          <div className="d-flex justify-content-left mt-1 mb-3">
            <Button
              variant="primary"
              className="cl-btn-primary"
              onClick={() => {
                onApplyFilters({
                  ...filter,
                });
              }}
            >
              Search
            </Button>
            <Button
              variant="outline-primary"
              className="mx-2 cl-btn-outline-primary"
              onClick={() => {
                onResetFilter();
              }}
            >
              Reset
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LeavesFilter;
